var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useEffect, useState } from "react";
import { getClientDropdownData } from "../../../../api/marketData/AllStaffCrud";
import { UuiFlexlayout } from "@aonunited/react";
import { AonButton } from "../../../../components/core/AonButton";
import { BUTTON_VARIANT } from "../../../../components/core/AonButton/consts";
import "./commonFilter.scss";
import { useClientPageStore, useErrorStore } from "../../../../store";
import { AddRemoveUpdateClientDailog } from "../../../Dailog/AddRemoveUpdateClient";
import { observer } from "mobx-react";
import { useNavigate } from "react-router-dom";
import { AonCustomSearchDropDown } from "./AonCustomSearch";
import AddNewClient from "../../../Dailog/AddNewClient";
var CommonFilter = observer(function () {
    //use states
    var _a = useState(""), searchValue = _a[0], setSearchValue = _a[1];
    var _b = useState([]), allDropDownOptions = _b[0], setAllDropDownValues = _b[1];
    var _c = useState(null), debounceTimer = _c[0], setDebounceTImer = _c[1];
    var _d = useState(false), showAddClientModal = _d[0], setShowAddClientModal = _d[1];
    var _e = useState(false), showAddNewClientModal = _e[0], setShowAddNewClientModal = _e[1];
    var _f = useState(""), actionType = _f[0], setActionType = _f[1];
    var clientStore = useClientPageStore();
    var navigation = useNavigate();
    var errorStore = useErrorStore();
    var _g = useState(""), message = _g[0], setMessage = _g[1];
    useEffect(function () {
        var inputRef = document.getElementById("__searchInputId__");
        if (inputRef) {
            inputRef.addEventListener("keydown", function (Event) {
                if (Event.key === "Enter") {
                    fetchAllSearchdata(Event === null || Event === void 0 ? void 0 : Event.target);
                    Event === null || Event === void 0 ? void 0 : Event.preventDefault();
                }
            });
        }
    }, []);
    var fetchAllSearchdata = function () {
        var args_1 = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args_1[_i] = arguments[_i];
        }
        return __awaiter(void 0, __spreadArray([], args_1, true), void 0, function (_searchValue) {
            var value, res, options, error_1;
            if (_searchValue === void 0) { _searchValue = ""; }
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        value = _searchValue ? _searchValue : searchValue;
                        if (!value) {
                            return [2 /*return*/];
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        clientStore.setApiLoading(true);
                        return [4 /*yield*/, getClientDropdownData({ QuickSearch: value })];
                    case 2:
                        res = _a.sent();
                        options = res.data.value.map(function (item) { return (__assign({ label: "".concat(item.name, " (").concat(item.code, ")"), value: item.clientGuid }, item)); });
                        setAllDropDownValues(options);
                        clientStore.setApiLoading(false);
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _a.sent();
                        console.log(error_1);
                        clientStore.setApiLoading(false);
                        errorStore.showError({ message: "Error", code: "500" });
                        navigation('/error');
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    var openAddClientModal = function (action) {
        if (action === "ADD") {
            setActionType("ADD");
        }
        else if (action === "REMOVE") {
            setActionType("REMOVE");
        }
        else {
            setActionType("CHANGE");
        }
        setShowAddClientModal(true);
    };
    var handleSelectedClient = function (value) { return __awaiter(void 0, void 0, void 0, function () {
        var findSelected, result;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    setMessage("");
                    findSelected = allDropDownOptions.find(function (data) { return data.value === value; });
                    if (!findSelected) return [3 /*break*/, 2];
                    return [4 /*yield*/, clientStore.selectClient(findSelected.value, findSelected)];
                case 1:
                    result = _b.sent();
                    if (!result.success) {
                        setMessage((_a = result.message) !== null && _a !== void 0 ? _a : "");
                        clearClientDetails();
                    }
                    _b.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    }); };
    var clearClientDetails = function () {
        clientStore.setSelectedClientGuuid("");
        clientStore.storeSelectedClientDetails(null);
    };
    useEffect(function () {
        var _a;
        if ((_a = clientStore.selectedClientDetails) === null || _a === void 0 ? void 0 : _a.label) {
            setSearchValue(clientStore.selectedClientDetails.label);
        }
    }, [clientStore.selectedClientDetails]);
    var debounce = function (func, timer) {
        return function (text, isEnterClicked) {
            if (isEnterClicked === void 0) { isEnterClicked = false; }
            if (!text) {
                setAllDropDownValues([]);
                clearClientDetails();
            }
            setSearchValue(text);
            clearTimeout(debounceTimer);
            setDebounceTImer(setTimeout(function () {
                if (isEnterClicked && text.length) {
                    func(text);
                }
                else if (text.length > 1) {
                    func(text);
                }
            }, timer));
        };
    };
    var InputDebounce = debounce(fetchAllSearchdata, 300);
    useEffect(function () {
        return function () {
            clearClientDetails();
        };
    }, []);
    return (React.createElement("div", null,
        React.createElement("div", null,
            React.createElement(UuiFlexlayout, { className: "common-filter-wrapper", direction: 'row', gap: 'lg', style: { marginBlock: "20px" } },
                React.createElement("div", { style: { width: "340px" } },
                    React.createElement(AonCustomSearchDropDown, { searchValue: searchValue, handleText: InputDebounce, allOptions: __spreadArray([], allDropDownOptions.map(function (item) { return ({ lable: item.label, value: item.value, }); }), true), fetching: clientStore.apiLoading, onSelectOption: handleSelectedClient })),
                clientStore.selectedClientDetails && clientStore.showClientFeatures &&
                    React.createElement(UuiFlexlayout, { direction: 'row', gap: 'lg' },
                        React.createElement(AonButton, { disabled: !clientStore.isUserHaveFullAccess, variant: BUTTON_VARIANT.DEFAULT, onClick: function () { return openAddClientModal('REMOVE'); } }, "Remove"),
                        React.createElement(AonButton, { disabled: !clientStore.isUserHaveFullAccess, variant: BUTTON_VARIANT.DEFAULT, onClick: function () { return openAddClientModal('CHANGE'); } }, "Change")),
                React.createElement(UuiFlexlayout, { direction: 'row', gap: 'lg' },
                    React.createElement(AonButton, { variant: BUTTON_VARIANT.DEFAULT, onClick: function () { return setShowAddNewClientModal(true); } }, "Add New Client")),
                React.createElement("div", { className: "error-message" },
                    React.createElement("span", null, message))),
            showAddClientModal && React.createElement(AddRemoveUpdateClientDailog, { showDailog: showAddClientModal, onClickClose: function () { return setShowAddClientModal(false); }, action: actionType }),
            showAddNewClientModal && React.createElement(AddNewClient, { showDialog: showAddNewClientModal, onClickClose: function () { return setShowAddNewClientModal(false); } }))));
});
export { CommonFilter };
